/* Zeker Product Page v1
   - Oculta botón Comprar/Pagar (dynamic checkout)
   - Botón Añadir al carrito en rojo #BD0010
   - Muestra precio del producto en el botón
*/
(function(){
  if (window.location.pathname.indexOf('/products/') === -1) return;

  /* Ocultar dynamic checkout (Comprar ahora / Pagar) */
  var hideStyle = document.createElement('style');
  hideStyle.textContent =
    '.shopify-payment-button, [data-shopify="payment-button"], .dynamic-checkout-cart, .no-js-hidden + div { display:none !important; }' +
    'form[action*="/cart/add"] button[type="submit"], .product-form__submit {' +
    '  background:#BD0010 !important;' +
    '  background-color:#BD0010 !important;' +
    '  border-color:#BD0010 !important;' +
    '  color:white !important;' +
    '}';
  document.head.appendChild(hideStyle);

  function getPrice() {
    var selectors = [
      '.price__current .money',
      '.price-item--regular',
      '[data-price-wrapper] .money',
      '.product__price .money',
      '.price .money',
      '[data-product-price]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.textContent.trim()) return el.textContent.trim();
    }
    return null;
  }

  function updateAddToCartBtn() {
    var btn = document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
              document.querySelector('.product-form__submit') ||
              document.querySelector('[name="add"]');
    if (!btn) return;

    var price = getPrice();
    if (!price) return;

    /* Buscar el span de texto dentro del boton */
    var textSpan = btn.querySelector('.button-text') ||
                   btn.querySelector('span:not([class*="icon"]):not([class*="loading"])') ||
                   btn.querySelector('span');

    var newText = 'Añadir al carrito · ' + price;

    if (textSpan) {
      textSpan.textContent = newText;
    } else if (!btn.querySelector('img') && !btn.querySelector('svg')) {
      btn.textContent = newText;
    }
  }

  /* Ejecutar en carga */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      setTimeout(updateAddToCartBtn, 400);
      setTimeout(updateAddToCartBtn, 1200);
    });
  } else {
    setTimeout(updateAddToCartBtn, 400);
    setTimeout(updateAddToCartBtn, 1200);
  }

  /* Actualizar al cambiar variante */
  document.addEventListener('change', function(e) {
    if (e.target.name === 'id' || e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(updateAddToCartBtn, 350);
    }
  });

  /* Observar cambios de precio por Alpine/JS */
  var priceObserver = new MutationObserver(function(){
    clearTimeout(window.zkPriceTimer);
    window.zkPriceTimer = setTimeout(updateAddToCartBtn, 300);
  });
  var priceEl = document.querySelector('.price') || document.querySelector('[data-price-wrapper]');
  if (priceEl) priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });

})();